export default "__VITE_ASSET__70e75b8f__"